import { store } from '../../store'
import { http } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get_permission ({ commit, dispatch }, payload) {
    let url = 'api/permissions'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('permissionGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  post_permission ({ commit, dispatch }, payload) {
    let url = 'api/permissions'
    let params = {
      'name': payload.event.item.name
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.post(url, params, {})
      .then(
        response => {
          commit('permissionPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  put_permission ({ commit, dispatch }, payload) {
    let url = 'api/permissions/' + payload.event.item.id
    let params = {
      'name': payload.event.item.name
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.put(url, params, {})
      .then(
        response => {
          commit('permissionPut', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  delete_permission ({ commit, dispatch }, payload) {
    let url = 'api/permissions/' + payload.event.item.id
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.delete(url, {}, {})
      .then(
        response => {
          commit('permissionDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  // Set the data obtained from the permissions endpoint
  permissionGet (state, payload) {
    payload.event.context.permissions = payload.response.data.data
  },
  // Add the data from the new permission to the permissions list
  permissionPost (state, payload) {
    let permission = payload.response.data.data
    permission.name = permission.name
    let permissions = payload.event.context.permissions
    permissions.push(permission)
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  // Updates the data displayed for the modified permissions
  permissionPut (state, payload) {
    let permission = payload.response.data.data
    permission.name = permission.name
    let permissions = payload.event.context.permissions
    permissions.splice(payload.event.index, 1, permission)
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  // Removes the data of the deleted permission from the permissions list
  permissionDelete (state, payload) {
    let permissions = payload.event.context.permissions
    permissions.splice(payload.event.index, 1)
    // payload.event.context.users = users
    payload.event.context.showNotification(payload.response, 'success')
  },
  // Shows a error message
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/permissions.js